import { ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';

export const Tile = ({ children, className }: { children: ReactNode; className?: string }) => {
  return (
    <div
      className={twMerge('flex flex-col gap-y-4 p-7 bg-neutral-1000 border border-neutral-900 rounded-2xl', className)}
    >
      {children}
    </div>
  );
};
